import fetch from 'isomorphic-fetch'
import Config from 'config'

const API_KEY = Config.googleFontApiKey;
const GOOGLE_FONT_URL = Config.googleFontApiUrl;

export default class GoogleFontClient {

  getFontList(){
    const url = `${GOOGLE_FONT_URL}?key=${API_KEY}`
    return fetch(url, {method: "GET"})
      .then(res => res.json())
  }
}



// WEBPACK FOOTER //
// ./src/services/GoogleFontClient.js